export default __webpack_public_path__ + "static/media/forgotpassword.0d565454.png";